module.exports = __webpack_public_path__ + "static/horse-5f043c2ebeff55546fdfae2dfbc57f1a.png";